const state = {
  showSidebar: true,
  minibar:false ,
  profile : {
  		avatar : '/app/image'
  }
};

export default state;



// WEBPACK FOOTER //
// ./src/store/sidebar/index.js